/**
 * Implicit Cookie Consent Script
 * Handles storing consent when user clicks checkout, without blocking flow.
 * Now also records consent in Shopify Admin via Cart Attributes.
 */
(function () {
  "use strict";

  // Function to check if user is logged in (helpers)
  function isUserLoggedIn() {
    const customerElement = document.querySelector('[data-customer-logged-in], [data-user-logged-in]');
    const logoutLink = document.querySelector('a[href="/account/logout"]');
    return !!(customerElement || logoutLink);
  }

  // Global functions (api compatibility)
  window.ConsentPopup = {
    isConsentGiven: function () {
      return true;
    },
    showPopup: function (callback) {
      if (callback) callback();
    }
  };

  const checkoutSelectors = [
    '.cart__checkout',
    '.btn-checkout',
    '.btn--checkout',
    '[name="checkout"]',
    '.rebuy-cart__checkout-button',
    '#buyNow1CheckoutBtn',
    '.checkout-btn',
    'a[href="/checkout"]',
    'a[href^="/checkout"]',
    'a[href^="/cart/checkout"]',
    '.shopify-payment-button__button',
    '[data-testid="Checkout-button"]'
  ];

  /**
   * Inject hidden input into form to capture cart attributes
   */
  function injectAttribute(form, name, value) {
    let input = form.querySelector(`input[name="attributes[${name}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `attributes[${name}]`;
      form.appendChild(input);
    }
    input.value = value;
  }

  /**
   * Update cart attributes via AJAX for non-form interactions
   */
  function updateCartAttributesAJAX(callback) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Consent Given': 'Yes',
          'Consent Timestamp': new Date().toISOString()
        }
      })
    }).finally(() => {
      if (callback) callback();
    });
  }

  function handleCheckoutAction(e) {
    // 1. Store in LocalStorage (Desktop/Mobile tracking)
    const isLoggedIn = isUserLoggedIn();
    const timestamp = new Date().getTime().toString();

    if (isLoggedIn) {
      localStorage.setItem('checkout_consent_given', 'true');
      localStorage.setItem('checkout_consent_timestamp', timestamp);
    } else {
      localStorage.setItem('checkout_consent_given_guest', 'true');
      localStorage.setItem('checkout_consent_timestamp_guest', timestamp);
    }

    // 2. Store in Shopify Admin (Cart Attributes)
    const target = e.currentTarget;
    const form = target.tagName === 'FORM' ? target : target.closest('form');

    if (form) {
      // If it's a form, inject attributes so they submit with the checkout
      injectAttribute(form, 'Consent Given', 'Yes');
      injectAttribute(form, 'Consent Timestamp', new Date().toISOString());
    } else {
      // If it's a loose button or link, attempt to sync via AJAX
      if (target.tagName === 'A' && target.href && !target.dataset.consentSynced) {
        // Delay link navigation slightly to ensure AJAX request is initiated
        e.preventDefault();
        target.dataset.consentSynced = 'true';
        updateCartAttributesAJAX(() => {
          window.location.href = target.href;
        });
      } else {
        updateCartAttributesAJAX();
      }
    }
  }

  function attachHandlers() {
    const buttons = document.querySelectorAll(checkoutSelectors.join(', '));
    buttons.forEach(btn => {
      if (btn.dataset.implicitConsentAttached) return;
      btn.dataset.implicitConsentAttached = 'true';
      btn.addEventListener('click', handleCheckoutAction, { capture: true });
    });

    const forms = document.querySelectorAll('form[action="/cart"], form[action="/checkout"]');
    forms.forEach(form => {
      if (form.dataset.implicitConsentAttached) return;
      form.dataset.implicitConsentAttached = 'true';
      form.addEventListener('submit', handleCheckoutAction, { capture: true });
    });
  }

  // Init
  attachHandlers();

  // Observer for dynamic buttons
  const observer = new MutationObserver(() => attachHandlers());
  observer.observe(document.body, { childList: true, subtree: true });

})();